export enum AmendReason {
    RecordedIncorrectQuantity = 0,
    ReturnedToStock,
    RecordedIncorrectDrugNdc,
    RecordedIncorrectRxNumberAndOrPatientName,
    ReturnedToWholesaler,
    Other
}